var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ul", { staticClass: "nav go-tab-pills" }, [
    _c("li", { staticClass: "go-tab-item" }, [
      _c(
        "a",
        {
          staticClass: "go-tab-link active",
          attrs: { "data-toggle": "tab" },
          on: {
            click: function ($event) {
              return _vm.change("ALL", _vm.DISCOVERY_SCRAP_TYPE.ALL)
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("global.scrape.tabs.all")))]
      ),
    ]),
    _vm._v(" "),
    _c("li", { staticClass: "go-tab-item" }, [
      _c(
        "a",
        {
          staticClass: "go-tab-link",
          attrs: { "data-toggle": "tab" },
          on: {
            click: function ($event) {
              return _vm.change("CLOUD", _vm.DISCOVERY_SCRAP_TYPE.CLOUD)
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("global.scrape.tabs.cloud")))]
      ),
    ]),
    _vm._v(" "),
    _c("li", { staticClass: "go-tab-item" }, [
      _c(
        "a",
        {
          staticClass: "go-tab-link",
          attrs: { "data-toggle": "tab" },
          on: {
            click: function ($event) {
              return _vm.change("SOCIAL", _vm.DISCOVERY_SCRAP_TYPE.SOCIAL)
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("global.scrape.tabs.social")))]
      ),
    ]),
    _vm._v(" "),
    _c("li", { staticClass: "go-tab-item" }, [
      _c(
        "a",
        {
          staticClass: "go-tab-link",
          attrs: { "data-toggle": "tab" },
          on: {
            click: function ($event) {
              return _vm.change("BLOG", _vm.DISCOVERY_SCRAP_TYPE.BLOG)
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("global.scrape.tabs.blog")))]
      ),
    ]),
    _vm._v(" "),
    _c("li", { staticClass: "go-tab-item" }, [
      _c(
        "a",
        {
          staticClass: "go-tab-link",
          attrs: { "data-toggle": "tab" },
          on: {
            click: function ($event) {
              return _vm.change("RSS", _vm.DISCOVERY_SCRAP_TYPE.RSS)
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("global.scrape.tabs.rss")))]
      ),
    ]),
    _vm._v(" "),
    _c("li", { staticClass: "go-tab-item" }, [
      _c(
        "a",
        {
          staticClass: "go-tab-link",
          attrs: { "data-toggle": "tab" },
          on: {
            click: function ($event) {
              return _vm.change("EMAIL", _vm.DISCOVERY_SCRAP_TYPE.EMAIL)
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("global.scrape.tabs.email")))]
      ),
    ]),
    _vm._v(" "),
    _c("li", { staticClass: "go-tab-item" }, [
      _c(
        "a",
        {
          staticClass: "go-tab-link",
          attrs: { "data-toggle": "tab" },
          on: {
            click: function ($event) {
              return _vm.change("URL", _vm.DISCOVERY_SCRAP_TYPE.URL)
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("global.scrape.tabs.url")))]
      ),
    ]),
    _vm._v(" "),
    _c("li", { staticClass: "go-tab-item" }, [
      _c(
        "a",
        {
          staticClass: "go-tab-link",
          attrs: { "data-toggle": "tab" },
          on: {
            click: function ($event) {
              return _vm.change(
                "MS_TOPIC",
                _vm.DISCOVERY_SCRAP_TYPE.META_SEARCH
              )
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("global.scrape.tabs.ms-search")))]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }